module.exports = __webpack_public_path__ + "static/media/ExcelExportDisabled.b9e75def.svg";